import { map } from "rxjs";
import { GET, POST } from "../../../../module/services/fetch";

export const fetchGetAllUsers = (payload: any) => {
  const { callBody, sortBy } = payload;
  return POST(
    `admin/users/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    callBody
  ).pipe(map((response: any) => response));
};

export const fetchUserEntitlementRequest = (
  selectedUser: any[],
  fetchBusinessRole: boolean = true
) =>
  POST(`entitlements/searchByUserId?businessRole=true`, selectedUser).pipe(
    map((response: any) => response)
  );

export const fetchDateEntitlementRequest = (
  userCode: string | number,
  timeStamp: number
) =>
  GET(
    `admin/user/${userCode}/entitlements?businessRole=false&snapshotDate=${timeStamp}`
  ).pipe(map((response: any) => response));

export const fetchCreateRequest = (abilitationObj: FormData) =>
  POST(
    "request/createRequests",
    abilitationObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));
